module.exports = "/_next/static/images/icon_plus-7d7087d2ac9ea3fcca92276f02102cb8.svg";